import { PayrollCycle } from '@zorro/clients';
import { $enum } from 'ts-enum-util';

export const getWeeksFromPayrollCycle = (
  payrollCycle?: PayrollCycle | null
): number => {
  if (!payrollCycle) {
    return Number.NaN;
  }

  return $enum.mapValue(payrollCycle).with({
    [PayrollCycle.WEEKLY]: 52,
    [PayrollCycle.WEEKLY_DEDUCTIONS]: 48,
    [PayrollCycle.BIWEEKLY]: 26,
    [PayrollCycle.BIWEEKLY_DEDUCTIONS]: 24,
    [PayrollCycle.MONTHLY]: 12,
    [PayrollCycle.SEMI_MONTHLY]: 24,
  });
};
